import { Component } from '@angular/core';
import { BaseMenuComponent } from './base.menu';
import { ModalComponent } from '../modal/modal.component';

@Component({
    templateUrl: './action-plan-list.menu.html',
    standalone: false
})
export class ActionPlanListMenuComponent extends BaseMenuComponent {
  constructor(public modal: ModalComponent) {
    super(modal);
  }
}
